@let searchTextControlValue = searchTextControl();

<ng-container *transloco="let t; prefix: i18nPrefix()">
  <mat-card class="w-full mb-4">
    <mat-card-content>
      <div class="w-full flex flex-col md:flex-row justify-between gap-6">
        <mat-form-field class="max-md:w-full md:w-[400px]" subscriptSizing="dynamic">
          <!-- TODO SEARCH_TEXT TO GLOBAL PATH -->
          <mat-label>{{ t('FILTER.SEARCH_TEXT') }}</mat-label>
          <input matInput name="search-text" type="text" [formControl]="searchTextControlValue" />
          @if (!(searchTextControlValue.value | isNil) && searchTextControlValue.value !== '') {
            <button
              mat-icon-button
              matSuffix
              type="button"
              (click)="searchTextControlValue.reset()"
            >
              <mat-icon customMatSvgIcon="pct-mdi-close-circle" />
            </button>
          }
          <mat-error [control]="searchTextControlValue" />
        </mat-form-field>
        @let buttonsTemplateRefValue = buttonsTemplateRef();
        @if (buttonsTemplateRefValue !== undefined) {
          <div class="flex flex-col md:flex-row items-center gap-4">
            <ng-container *ngTemplateOutlet="buttonsTemplateRefValue" />
          </div>
        }
      </div>
    </mat-card-content>
  </mat-card>

  @let filtersTemplateRefValue = filtersTemplateRef();
  @if (filtersTemplateRefValue !== undefined) {
    <mat-accordion>
      <mat-expansion-panel
        [expanded]="isExpandedFilterPanel()"
        (closed)="isExpandedFilterPanelChange$.next(false)"
        (opened)="isExpandedFilterPanelChange$.next(true)"
      >
        <mat-expansion-panel-header id="list-filter-panel-header">
          <!-- TODO PANEL_TITLE TO GLOBAL PATH -->
          <mat-panel-title>{{ t('FILTER.PANEL_TITLE') }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="flex flex-col md:flex-row md:flex-wrap gap-4"
          ><ng-container *ngTemplateOutlet="filtersTemplateRef()!"
        /></div>
      </mat-expansion-panel>
    </mat-accordion>
  }
</ng-container>
